import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return this.props.fallback || (
        <div className="p-4 border border-red-200 rounded-lg bg-red-50 dark:bg-red-900/20 dark:border-red-800">
          <h3 className="text-sm font-medium text-red-800 dark:text-red-200">
            Ett fel uppstod i diagrammet
          </h3>
          <p className="mt-1 text-sm text-red-600 dark:text-red-300">
            Diagrammet kunde inte visas på grund av ogiltig data. Försök att välja en annan kommun eller KPI.
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
